import styled from 'styled-components'

import media from 'utils/media'

const Main = styled.main`
   padding-top: 80px;
   background-color: ${({ theme }) => theme.colors.mainBG};
   color: ${({ theme }) => theme.colors.textColor};

   ${media.greaterThan('md')`
      overflow: hidden;
  `};
`

export default Main
